import React from "react";
import { useModal } from "./context/modal-provider";

export const ModalRoot: React.FC = () => {
  const { component, props, hideModal } = useModal();
  // TODO: Fix any
  const ModalComponent: React.ComponentType<any> | null = component;
  return ModalComponent ? <ModalComponent {...props} onClose={hideModal} /> : null;
};
